import { QueryClient } from "@tanstack/react-query";
import { isNotFoundError, isUnauthorizedError } from "@/api/util";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: (failureCount, error) =>
        !isUnauthorizedError(error) &&
        !isNotFoundError(error) &&
        failureCount < 1,
    },
  },
});
